<div id="layoutSidenav">
    <div id="layoutSidenav_content">
        <main>

            <div class="container-fluid px-5 pt-5 mt-4">
                <!-- Total Leads Section -->
                <!-- Coupon Banner -->


                <h2 class="mb-4">My Staff ({{totalRecords || 0}})</h2>
                <div style="float: right;">
                    <button type="button" class="btn btn-primary" (click)="addStaff()">Add Staff</button>
                </div>


                <!-- Data Table -->
                <div class="table-responsive">
                    <table mat-table class="table table-hover">
                        <thead class="table-primary">
                            <tr>

                                <th>S.No</th>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Mobile</th>
                                <th>City</th>
                                <th>District</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngFor="let records of paginatedRecords;  let i = index">
                                <tr  [ngClass]="{'blocked-row': records.activeStatus === 2}">
                                    <td>{{ (pageIndex * pageSize) + (i + 1) }}</td>
                                    <td>{{records.personalDetails.firstName}}</td>
                                    <td>{{records.personalDetails.email}}</td>
                                    <td>{{records.personalDetails.mobile}}</td>
                                    <td>{{records.personalDetails.city}}</td>
                                    <td>{{records.personalDetails.district}}</td>
                                    <td><button class="btn btn-sm btn-outline-danger" *ngIf="records.activeStatus !== 2"(click)="confirmBlock(records)">
                                              <i class="fa-solid fa-lock"></i>
                                        </button> <button class="btn btn-sm btn-outline-danger" *ngIf="records.activeStatus == 2"(click)="confirmUnblock(records)">
                                              <i class="fa-solid  fa-unlock"></i>
                                        </button> &nbsp;<button class="btn btn-sm btn-outline-primary me-2"
                                            (click)="toggleRow(i)"><i
                                                class="fa-solid fa-clock-rotate-left"></i></button></td>

                                </tr>
                                <ng-container *ngIf="expandedIndex === i">
                                    <tr>
                                        <td colspan="12" class="bg-light">
                                            <div class="p-2 border w-75 bg-white rounded-1 m-auto text-wrap td-data">
                                                <a (click)="toggleRow(i)" style="cursor: pointer;"><i
                                                        class="fa-solid fa-chevron-up text-right d-block mb-2"></i> </a>
                                                <p *ngFor="let history of childData" class="mb-1">
                                                    {{history.type}}- <b>Activity Date</b>: <b class="text-primary"
                                                        style="color: green;">{{history.createdAt |
                                                        date:'short':'IST'}} </b>
                                                </p>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-container>
                            </ng-container>
                        </tbody>

                    </table>
                </div>
                <mat-paginator [length]="totalRecords" [pageSize]="pageSize" 
  showFirstLastButtons
                    (page)="onPageChange($event)">
                </mat-paginator>
            </div>
        </main>

    </div>
</div>